import React from 'react';
import PropTypes from 'prop-types';
import { Button, Grid } from '@material-ui/core';

const MenuControls = ({ handleClose, useFormSubmit, onSubmit, disabled }) => {
  const renderSubmitButton = () => {
    return useFormSubmit ? (
      <Button type="submit" variant="contained" color="primary" disabled={disabled}>
        Save
      </Button>
    ) : (
      <Button variant="contained" color="primary" onClick={onSubmit} disabled={disabled}>
        Save
      </Button>
    );
  };

  return (
    <Grid
      container
      direction="row"
      justify="flex-start"
      alignItems="flex-start"
      spacing={2}
      style={{ paddingLeft: '23px' }}
    >
      <Grid item xs="auto">
        {renderSubmitButton()}
      </Grid>
      <Grid item xs="auto">
        <Button color="primary" onClick={handleClose}>
          Cancel
        </Button>
      </Grid>
    </Grid>
  );
};

MenuControls.propTypes = {
  handleClose: PropTypes.func.isRequired,
  useFormSubmit: PropTypes.bool,
  disabled: PropTypes.bool,
  onSubmit: PropTypes.func
};

MenuControls.defaultProps = {
  useFormSubmit: true,
  onSubmit: null,
  disabled: false
};

export default MenuControls;
